import { render } from "./purchasehistoryView.vue?vue&type=template&id=1e865b7b&scoped=true"
import script from "./purchasehistoryView.vue?vue&type=script&lang=js"
export * from "./purchasehistoryView.vue?vue&type=script&lang=js"

import "./purchasehistoryView.vue?vue&type=style&index=0&id=1e865b7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e865b7b"]])

export default __exports__